import fetchLocation from "utils/fetch-locations"
import fetchSlugs from "utils/fetch-slugs"
import fetchSocialMedia from "utils/fetch-social-media"
import Layout from "components/Layout"
import ReferenceHero from "components/ReferenceHero"
import TargetSolution from "components/TargetSolution"
import DynamicContent from "components/content/DynamicContent"
import { createApolloClient } from "utils/apollo"
import { buildDetailQuery } from "utils/blueprints/references"
import fetchCompany from "utils/fetch-company"
import fetchNav from "utils/fetch-nav"
import { replaceVariables } from "utils/replaceVariables"

function ReferenzenPage({
  content,
  navs,
  company,
  locations,
  socialMediaLinks,
}) {
  return (
    <Layout
      navs={navs}
      company={company}
      content={content}
      locations={locations}
      socialMediaLinks={socialMediaLinks}
    >
      <ReferenceHero data={content} />
      <TargetSolution data={content} />
      <DynamicContent content={content} />
    </Layout>
  )
}

// Data for current page
// export const getServerSideProps = async (context) => {
export const getStaticProps = async (context) => {
  const slug = context.params.slug
  const { previewData } = context

  const apollo = createApolloClient(previewData?.token ?? null)

  const [res, navs, company, locations, socialMediaLinks] = await Promise.all([
    apollo.query({
      query: buildDetailQuery({
        slug,
        isPreview: !!context?.previewData?.token,
      }),
    }),
    fetchNav(apollo, previewData?.unit),
    fetchCompany(apollo, previewData?.unit),
    fetchLocation(apollo, previewData?.unit),
    fetchSocialMedia(apollo, previewData?.unit),
  ])

  if (res.errors?.length) {
    throw new Error(res.errors[0]?.message)
  }

  let content = (res?.data?.entries?.data || [])?.filter((e) => !!e)?.[0]

  if (!content) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      content: await replaceVariables(content),
      navs,
      company,
      locations,
      socialMediaLinks,
    },
    // revalidate: 30,
  }
}

// Generate static paths for SSR
export const getStaticPaths = async () => {
  let paths = await fetchSlugs("references")
  paths = paths.map((path) => path.url)

  return {
    paths,
    fallback: false,
  }
}

export default ReferenzenPage
